import { createContext, useEffect, useMemo, useState } from 'react';
import useQueryParams from '../hooks/useQueryParams';

const initialValues = {
  svcId: '',
  uuid: '',
  svcManagerId: '',
  svcAsId: '',
  svcSymptom: '',
  svcSymptomCode: '',
  accessToken: '',
  createDate: '',
  createTime: '',
  region: '',
  saUid: '',
};
export const RedirectParameterContext = createContext({
  redirectParameters: { ...initialValues },
  updateRedirectParameters: () => {},
});

const RedirectParameterProvider = ({ children }) => {
  const [redirectParameters, setRedirectParameters] = useState({
    ...initialValues,
  });
  const { getAllParams } = useQueryParams();
  useEffect(() => {
    setRedirectParameters(prevData => ({ ...prevData, ...getAllParams() }));
  }, [getAllParams]);

  // Update redirect parameters with new values
  const updateRedirectParameters = newParams => {
    setRedirectParameters(prevParams => ({
      ...prevParams,
      ...newParams,
    }));
  };

  const values = useMemo(
    () => ({
      redirectParameters,
      updateRedirectParameters,
    }),
    [redirectParameters, updateRedirectParameters]
  );

  return (
    <RedirectParameterContext.Provider value={values}>
      {children}
    </RedirectParameterContext.Provider>
  );
};

export default RedirectParameterProvider;
